import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-3",
  id: "text-colors"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#text-colors" }),
  /*#__PURE__*/_createTextVNode(" Theme Colors ")
], -1)
const _hoisted_3 = { class: "py-5" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" extends ")
const _hoisted_5 = /*#__PURE__*/_createVNode("a", {
  href: "https://getbootstrap.com/docs/5.0/customize/color/",
  class: "fw-bold"
}, "Bootstrap Colors", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("  system with extra variants to cover its own design system build on top of the Boostrap Standards. The extended theme color SASS variables are defined in ")
const _hoisted_7 = /*#__PURE__*/_createVNode("code", null, "src/sass/_variables.scss", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Custom variables that used to customize Bootstrap components are marked with ")
const _hoisted_10 = /*#__PURE__*/_createVNode("code", null, "Custom variable", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" comment in ")
const _hoisted_12 = /*#__PURE__*/_createVNode("code", null, "_variables.scss", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("  file.")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")
  const _component_Info = _resolveComponent("Info")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("b", null, _toDisplayString(_ctx.themeName), 1),
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8
    ]),
    _createVNode(_component_CodeHighlighter, {
      lang: "scss",
      fieldHeight: 300
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(`// Theme colors
$theme-colors: (
    "white":      $white,  // custom color type
    "primary":    $primary,
    "secondary":  $secondary,
    "success":    $success,
    "info":       $info,
    "warning":    $warning,
    "danger":     $danger,
    "light":      $light,
    "dark":       $dark
) !default;

// Hover colors
$theme-active-colors: (
    "white":      $white-active,   // custom color type
    "primary":    $primary-active,
    "secondary":  $secondary-active,
    "success":    $success-active,
    "info":       $info-active,
    "warning":    $warning-active,
    "danger":     $danger-active,
    "light":      $light-active,
    "dark":       $dark-active
) !default;  // Custom variable

// Inverse colors
$theme-inverse-colors: (
    "white":      $white-inverse,
    "primary":    $primary-inverse,
    "secondary":  $secondary-inverse,
    "success":    $success-inverse,
    "info":       $info-inverse,
    "warning":    $warning-inverse,
    "danger":     $danger-inverse,
    "light":      $light-inverse,
    "dark":       $dark-inverse
) !default;  // Custom variable

// Light colors
$theme-light-colors: (
    "white":      $white-light,
    "primary":    $primary-light,
    "secondary":  $secondary-light,
    "success":    $success-light,
    "info":       $info-light,
    "warning":    $warning-light,
    "danger":     $danger-light,
    "light":      $light-light,
    "dark":       $dark-light
) !default;  // Custom variable

// Text colors
$theme-text-colors: (
    "white":      $white,
    "primary":    $primary,
    "secondary":  $dark,
    "success":    $success,
    "info":       $info,
    "warning":    $warning,
    "danger":     $danger,
    "light":      $light,
    "dark":       $dark,
    "muted":      $text-muted,
    "gray-100":   $gray-100,
    "gray-200":   $gray-200,
    "gray-300":   $gray-300,
    "gray-400":   $gray-400,
    "gray-500":   $gray-500,
    "gray-600":   $gray-600,
    "gray-700":   $gray-700,
    "gray-800":   $gray-800,
    "gray-900":   $gray-900
) !default;  // Custom variable`), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_Info, null, {
      default: _withCtx(() => [
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _hoisted_13
      ]),
      _: 1
    })
  ]))
}